export default "__VITE_ASSET__BeyoTm8D__"